import React from 'react';
import i18 from '../../../i18';

class AssignmentRuleCreate extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.createInitialState(props);
    }

    createInitialState = (props) => {
        return {
            position: 5,

            itemNameEnabled: false,
            itemName: props.invoiceItem.name,

            invoiceNumberEnabled: false,
            invoiceNumber: props.invoice.invoiceNumber,

            positionNumberEnabled: false,
            positionNumber: props.invoice.positionNumber,

            positionNumberCountryEnabled: false,
            positionNumberCountry:
            props.invoice.positionNumberCountry,

            orderNumberStatEnabled: false,
            orderNumberStat: props.invoice.orderNumberStat,

            vat: props.invoiceItem.vat,
            company_type: props.invoice.company_type,

            vat_code: '',
            collector_code_fk_id: '',
            main_bookkeeping_number: '',

            saving: false,
        };
    };

    onElementChange = (event) => {
        const target = event.target;
        const name = target.name;

        if (target.type === 'checkbox') {
            this.setState({
                [name]: target.checked,
            });

            return;
        }

        if (name === 'itemName') {
            const itemName = target.value;
            const matches = itemName.match(/^#([0-9]+)\s*/);

            if (matches) {
                this.setState({
                    itemName: itemName.substring(
                        matches[0].length,
                    ),
                    position: parseInt(matches[1], 10),
                });

                return;
            }
        }

        this.setState({
            [name]: target.value,
        });
    };

    onKeyDown = (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        event.preventDefault();

        this.createRule('final');
    };

    isVatCodeRequired = () => {
        return String(
            this.state.collector_code_fk_id,
        ) !== '3';
    };

    ruleValidation = () => {
        const hasSelectedRuleFilter =
            this.state.itemNameEnabled
            || this.state.invoiceNumberEnabled
            || this.state.orderNumberStatEnabled
            || this.state.positionNumberEnabled
            || this.state.positionNumberCountryEnabled;

        if (!hasSelectedRuleFilter) {
            this.props.notifyError(
                'A szabály létrehozásához ki kell választani, '
                + 'hogy mely adatokra legyen érvényes!',
            );

            return false;
        }

        if (!this.state.main_bookkeeping_number.trim()) {
            this.props.notifyError(
                'Kérjük, töltse ki a [Főkönyvi szám] mezőt!',
            );

            return false;
        }

        if (!this.state.collector_code_fk_id) {
            this.props.notifyError(
                'Kérjük, töltse ki a [Gyűjtőkód] mezőt!',
            );

            return false;
        }

        if (
            this.isVatCodeRequired()
            && !this.state.vat_code.trim()
        ) {
            this.props.notifyError(
                'Kérjük, töltse ki az '
                + '[ÁFA főkönyvi szám] mezőt!',
            );

            return false;
        }

        return true;
    };

    createRulePayload = (type) => {
        return {
            item_name: this.state.itemNameEnabled
                ? this.state.itemName.trim()
                : '',

            position: parseInt(
                this.state.position,
                10,
            ),

            invoice_number:
                this.state.invoiceNumberEnabled
                    ? this.state.invoiceNumber.trim()
                    : '',

            vat: this.state.vat,
            company_type: this.state.company_type,
            type: type,

            position_number:
                this.state.positionNumberEnabled
                    ? this.state.positionNumber.trim()
                    : '',

            position_number_country:
                this.state.positionNumberCountryEnabled
                    ? this.state.positionNumberCountry.trim()
                    : '',

            main_bookkeeping_number:
                this.state.main_bookkeeping_number.trim(),

            order_number_stat:
                this.state.orderNumberStatEnabled
                    ? this.state.orderNumberStat.trim()
                    : '',

            collector_code_fk_id:
            this.state.collector_code_fk_id,

            vat_degree: this.isVatCodeRequired()
                ? this.state.vat_code.trim()
                : '',
        };
    };

    resetRuleFields = () => {
        this.setState({
            main_bookkeeping_number: '',
            collector_code_fk_id: '',
            vat_code: '',

            itemNameEnabled: false,
            invoiceNumberEnabled: false,
            positionNumberEnabled: false,
            positionNumberCountryEnabled: false,
            orderNumberStatEnabled: false,
        });
    };

    createRule = async (type) => {
        if (this.state.saving) {
            return;
        }

        if (!this.ruleValidation()) {
            return;
        }

        this.setState({
            saving: true,
        });

        try {
            const result = await this.props.createRule(
                this.createRulePayload(type),
            );

            /*
             * A parent false visszatérési értékkel jelezheti,
             * hogy a mentés sikertelen volt.
             */
            if (result !== false) {
                this.resetRuleFields();
            }
        } finally {
            this.setState({
                saving: false,
            });
        }
    };

    renderInputCheckbox = (property, className) => {
        return (
            <input
                name={property}
                checked={this.state[property]}
                type="checkbox"
                onChange={this.onElementChange}
                className={className}
                disabled={this.state.saving}
            />
        );
    };

    renderInputText = (
        property,
        className,
        inputProps,
    ) => {
        const extraProps = inputProps || {};

        return (
            <input
                {...extraProps}
                name={property}
                value={this.state[property]}
                className={className}
                type="text"
                onChange={this.onElementChange}
                onKeyDown={this.onKeyDown}
                disabled={
                    this.state.saving
                    || extraProps.disabled === true
                }
            />
        );
    };

    render() {
        const {
            invoice,
            invoiceItem,
            vatCollectorCodes,
        } = this.props;

        const vatCodeDisabled =
            !this.isVatCodeRequired();

        return (
            <tr>
                <td>
                    {this.renderInputCheckbox(
                        'invoiceNumberEnabled',
                    )}

                    {this.renderInputText(
                        'invoiceNumber',
                        'no-border-underline-text-input',
                    )}
                </td>
                <td>
                    {this.renderInputCheckbox(
                        'itemNameEnabled',
                    )}

                    {this.renderInputText(
                        'itemName',
                        'no-border-underline-text-input',
                    )}
                </td>

                <td>{invoice.tax_number}</td>
                <td>{invoice.company_name}</td>
                <td>{invoice.paymentMethodLabel}</td>


                <td>
                    {this.renderInputCheckbox(
                        'positionNumberEnabled',
                    )}

                    {this.renderInputText(
                        'positionNumber',
                        'no-border-underline-text-input',
                    )}
                </td>

                <td>
                    {this.renderInputCheckbox(
                        'positionNumberCountryEnabled',
                    )}

                    {this.renderInputText(
                        'positionNumberCountry',
                        'no-border-underline-text-input',
                    )}
                </td>

                <td>
                    {this.renderInputCheckbox(
                        'orderNumberStatEnabled',
                    )}

                    {this.renderInputText(
                        'orderNumberStat',
                        'no-border-underline-text-input',
                    )}
                </td>

                <td>
                    {this.renderInputText(
                        'main_bookkeeping_number',
                        'bordered-input',
                    )}
                </td>

                <td>
                    {parseInt(invoiceItem.vat, 10)}%
                </td>

                <td>
                    <select
                        name="collector_code_fk_id"
                        value={
                            this.state.collector_code_fk_id
                        }
                        className="minimal form-control"
                        onChange={this.onElementChange}
                        onKeyDown={this.onKeyDown}
                        disabled={this.state.saving}
                    >
                        <option value="">
                            Kérjük, válasszon
                        </option>

                        {vatCollectorCodes.map(
                            (collectorCode) => (
                                <option
                                    value={collectorCode.id}
                                    key={collectorCode.id}
                                >
                                    {collectorCode.code}
                                    &nbsp;
                                    ({collectorCode.title})
                                </option>
                            ),
                        )}
                    </select>
                </td>

                <td>
                    {this.renderInputText(
                        'vat_code',
                        'bordered-input',
                        {
                            disabled: vatCodeDisabled,
                        },
                    )}
                </td>

                <td>
                    <i
                        onClick={
                            this.state.saving
                                ? null
                                : () => this.createRule('final')
                        }
                        title={
                            i18.CUSTOMER
                                ._createRulesAndProcess
                        }
                        className={
                            this.state.saving
                                ? 'fa fa-dot-circle-o disabled'
                                : 'fa fa-dot-circle-o'
                        }
                        aria-hidden="true"
                    />

                    &nbsp;&nbsp;

                    <i
                        onClick={
                            this.state.saving
                                ? null
                                : () => this.createRule(
                                    'temporarily',
                                )
                        }
                        title={
                            i18.CUSTOMER
                                ._oneTimeProcessing
                        }
                        className={
                            this.state.saving
                                ? 'fa fa-check-circle disabled'
                                : 'fa fa-check-circle'
                        }
                        aria-hidden="true"
                    />
                </td>
            </tr>
        );
    }
}

export default AssignmentRuleCreate;


// WEBPACK FOOTER //
// ./src/components/customer/steps/AssignmentRuleCreate.js